import VerificationContainer from "../../../Component/Application/ExhibitorAccessManagement/verification-container";

const ExhibitorAccessManagementPage = () => {
    return (
        <div className="page-body">
            <VerificationContainer />
        </div>
    );
};

export default ExhibitorAccessManagementPage;